/**
 * Created by istvan.rozsa on 2017. 04. 25..
 */
/**
 * Mivel a a ui-tags-input direktíva validációja nem szabható kellőképpen testre, ezért kiegészítettük
 */

class tagsInputController {

	constructor($scope) {
		'ngInject';
		this.$scope = $scope;

		this.validationTimer = setInterval(() => {
			const re = new RegExp(this.validationPattern);
			const email = document.getElementsByClassName('tags')[0].children[1].value;
			const isValid = re.test(document.getElementsByClassName('tags')[0].children[1].value);// valid case

			this.formInput.$setValidity('pattern', !email || isValid);


			this.formInput.$setValidity('leftoverText', true);
		}, 10);
	}

	$onInit() {
		this.originalHintList = angular.copy(this.removeUnnecessaryDevTestAndProdSysEmailAddressesFromEmailList(this.hintList));
	}

	removeUnnecessaryDevTestAndProdSysEmailAddressesFromEmailList(emails) {
		if (!emails || !emails.length) {
			return [];
		}
		return emails.filter(email => !email.includes('@ebizdevsrvv2.westeurope.cloudapp.azure.com') && !email.includes('@ebiztesztui.westeurope.cloudapp.azure.com') && !email.includes('@sys.otpebiz.hu'));
	}

	$onDestroy() {
		clearTimeout(this.validationTimer);
	}

	$onChanges(values) {
		// Initkor még nincs feltétlen értéke a hintlistnek mivel ajax hívással kapjuk meg, így előfordulhat, hogy nem állítódik be az originalHintList ami anomáliákat okozhat
		if (values.hintList.currentValue) {
			this.originalHintList = angular.copy(this.removeUnnecessaryDevTestAndProdSysEmailAddressesFromEmailList(values.hintList.currentValue));
		}
	}

	hintLoaded() {
		this.hintHolder = document.getElementsByClassName('hint-holder')[0];
		this.finalDiv = document.getElementById('final-div');
	}

	// Hintre kattintva hozzáadjuk az email listához az elemet, majd töröljük a hint listából
	addHintToEmailList(email) {
		// Ezt hagyjuk meg, szükség lehet még rá
		// document.getElementsByClassName('tags')[0].children[1].value = '';

		let emailModel = { text: email };

		if (this.onTagAdding(emailModel) && this.checkIfExists(email) === false) {
			this.tagsModel.push(emailModel);
			this.onTagAdded(emailModel);
		}
	}

	// Megnézzük, hogy a tagsModelben szerepel-e már a megadott e-mail cím
	checkIfExists(email) {
		return !!this.tagsModel.filter( model => model.text == email).length > 0;
	}

	showMoreButton() {
		if (this.hintList && this.hintList.length > 0) {
			return this.finalDiv.offsetTop - this.hintHolder.offsetHeight > this.hintHolder.offsetTop;
		}
		return false;
	}

	showMoreHints() {
		this.hintHolder.style.maxHeight = this.hintHolder.offsetHeight + 167 + 'px';
	};

	getPlaceHolder(addEmailAddress, addMoreEmailAddresses) {
		let placeholder;

		if (this.tagsModel && this.tagsModel.length) {
			placeholder = addMoreEmailAddresses;
		} else {
			placeholder = addEmailAddress;
		}

		return placeholder;
	};
	onTagAdding(tag) {
		if (!this.validationPattern) {
			return;
		}

		if (this.mappedEmails && this.mappedEmails.hasOwnProperty('primaryAndSecondary') && this.mappedEmails.primaryAndSecondary) {
			if (this.emailIsUnique(this.mappedEmails.primaryAndSecondary, tag.text)) {
				this.formInput.$setValidity('emailExistsInPrimaryOrSecondaryContactListValid', true);
			} else {
				this.formInput.$setValidity('emailExistsInPrimaryOrSecondaryContactListValid', false);
				return false;
			}
		}

		let re = new RegExp(this.validationPattern);
		this.formInput.$setTouched(true);

		if (tag) {
			var isValid = re.test(tag.text);// valid case
			if (!isValid) {
				this.formInput.$setValidity('minTags', isValid);
			}

			return isValid;
		}
		return false;
	};

	emailIsUnique(list, email) {
		if (list && list.length && email.length > 5 && list.includes(email)) {
			return false;
		}

		return true;
	}

	onTagAdded(tag) {
		if(this.tagsModel) {
			let maxLength = 10;

			if (this.maxEmailLength && !isNaN(+this.maxEmailLength)) {
				maxLength = +this.maxEmailLength;
			}
			if (this.tagsModel.length > maxLength) {
				this.formInput.$setValidity('length', false);
			} else {
				this.formInput.$setValidity('length', true);
			}
		}

		// Ha hintből jött az email, akkor törölnünk kell a hint listából
		if (this.originalHintList && this.originalHintList.includes(tag.text)) {
			var index = this.hintList.indexOf(tag.text);
			if (index !== -1) {
				this.hintList.splice(index, 1);
			}
		}

		document.getElementsByClassName('tags')[0].children[1].value = '';
		this.$scope.$emit('hintEmailAdded', tag.text);
	};

	onTagRemoved(tag) {
		if(this.tagsModel) {
			if (this.tagsModel.length < 11) {
				this.formInput.$setValidity('length', true);
			} else {
				this.formInput.$setValidity('length', false);
			}
		}

		// Ha hintből jött az email, akkor vissza kell raknunk a listába
		if (this.originalHintList && this.originalHintList.includes(tag.text)) {
			this.hintList.push(tag.text);
		}

		this.$scope.$emit('hintEmailRemoved', tag.text);
	};

	tagsInputKeydown(event) {
		setTimeout(() => {
			let currentUserInput = event.target.value;
			let emailTest = new RegExp(this.validationPattern);
			var isValidEmail = emailTest.test(currentUserInput);
			if (isValidEmail) {
				this.formInput.$setValidity('pattern', true);
			} else if (currentUserInput == '' && this.tagsModel.length < 11) {
				this.formInput.$setValidity('pattern', true);
			} else {
				this.formInput.$setValidity('pattern', false);
			}

			if (this.mappedEmails && this.mappedEmails.hasOwnProperty('primaryAndSecondary') && this.mappedEmails.primaryAndSecondary) {
				if (this.emailIsUnique(this.mappedEmails.primaryAndSecondary, event.target.value)) {
					this.formInput.$setValidity('emailExistsInPrimaryOrSecondaryContactListValid', true);
				} else {
					this.formInput.$setValidity('emailExistsInPrimaryOrSecondaryContactListValid', false);
				}
			}

		});
	};
}

export default tagsInputController;
